import { render, staticRenderFns } from "./Breads.vue?vue&type=template&id=9e678404&scoped=true&"
import script from "./Breads.vue?vue&type=script&lang=js&"
export * from "./Breads.vue?vue&type=script&lang=js&"
import style0 from "./Breads.vue?vue&type=style&index=0&id=9e678404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e678404",
  null
  
)

export default component.exports